





























































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import data from "@/services/data/danni-non-auto";
import categories from "@/services/categories";
import ComboBox from "@/components/ComboBox.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import moment from "moment";
import { isNil } from 'ramda';
import { it } from "vuejs-datepicker/dist/locale";
import {propertyTypes} from "@/services/properties";
import properties from "@/services/properties/danni-non-auto";
import { format } from "date-fns";
import Header from "@/components/Header.vue";
import {PnetDatatable} from '@previnet/vue-datatable';
import jquery from 'jquery';
import Datatable from 'datatables.net';
import responsive from 'datatables.net-responsive';
import fixedHeader from 'datatables.net-fixedheader-dt';
import fixedColumns from 'datatables.net-fixedcolumns-dt';
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js'
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4.min.js'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/js/fixedColumns.bootstrap4.min.js'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import config from "@/services/config";
import { mapGetters } from 'vuex';
import { Filter } from '@/services/filters';

const FILTER_KEY = "danni-non-auto-database";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user','filters','fromDashboard'],
  components: {
    PnetDatePicker,
    ComboBox,
    Header,
    MultiComboBox,
    PnetDatatable
  },
  computed: {
    ...mapGetters('filters', {
      filterById: 'byId',
    })
  },
  data: function() {
    return {
      config,
      fixedColumns,
      fixedHeader,
      jquery,
      loggedUser: this.$props.user,
      codCategoriaProdotto: categories.DANNI_NON_AUTO,
      listaProdottiCensiti: [] as any[],
      listaProdottiCensitiForTable: [] as any[],
      listaProdottiCensitiPaginati: [] as any[],
      listaProdottiCensitiCurrent: [] as any[],
      filterOptions: {
        prodottoCompleto: [],
        prodotto: [],
        compagnia: [],
        mercato: [],
        canale: [],
        distributori: [],
        modDistribuzione: [],
        lineaBusiness: [],
        prodottoInCommercio: [],
        tipologiaGaranzieMobilita: [],
        tipologiaGaranziePersona: [],
        tipologiaGaranzieCasaEFamiglia: [],
        tipologiaGaranzieAzienda: [],
        tipologiaGaranzieProfessionisti: [],
        tipoAssicurazione: [],
        premioTipologia: [],
      },
      changedFilterFields: [],
      options: {
        fixedHeader: true,
        fixedColumns: {
          leftColumns: 0
        },
        responsive: true,
        paging: false,
        scrollX: true,
        scrollY: "500px",
        scrollCollapse: true,
        dom: 'lfrti',
        searching: false,
        info: false,
        autoWidth: true,
        order: [4, "asc"],
        language: {
          emptyTable: 'Nessun prodotto censito'
        }
      },
      page: 1,
      totPages: 1,
      needsPagination: false,
      itemsPerPage: 20,
      pageStart: 1,
      pageEnd: 20,
      columns: [
        {
          label: '',
          field: 'isSelected',
          render: function(data: any, type: any, row: any) {
            return "<input type='checkbox' id='isSelectedProd_"+row.id+"' name='isSelectedProd_"+row.id+"' data-toggle='tooltip' data-placement='right' title='Seleziona prodotto' class='selectProd' value='true' />";
          },
          className: 'text-center',
          tag: 'caratteristiche_generali',
        },
        {
          label: 'Visualizza',
          modalLabel: 'Visualizza',
          field: 'isToModify',
          render: function(data: any, type: any, row: any) {
            //const m = "<button id='isToModifyProd_"+row.id+"' name='isToModifyProd_"+row.id+"' data-toggle='tooltip' title='Modifica prodotto' class='btn btn-table p-1 pl-2 modifyProd'><i class='fa fa-pencil-square-o' aria-hidden='true'></i></button>";-->
            const s = "<button id='isToShowProd_"+row.id+"' name='isToShowProd_"+row.id+"' data-toggle='tooltip' data-placement='right' title='Visualizza prodotto' class='btn btn-table p-1 showProd'><i class='fa fa-search' aria-hidden='true'></i></button>";
            
            //return m + s;
            return s;
          },
          className: 'text-center',
        },
        {
          label: 'Prodotto completo',
          modalLabel: 'Prodotto completo',
          field: 'prodottoCompleto',
          render: function(data: any, type: any, row: any) {
            return data ? "Sì" : "No";
          },
          className: 'text-center',
          checkVisible: true,
        },
        {
          label: 'Codice prodotto',
          modalLabel: 'Codice prodotto',
          field: 'productCode',
          checkVisible: true,
        },
        {
          label: 'Prodotto',
          modalLabel: 'Prodotto',
          field: 'prodotto',
          width: '300px',
          orderable: true,
          modalShowHidden: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Più versioni prodotto',
          modalLabel: 'Più versioni prodotto',
          field: 'piuTariffeProdotto',
          width: '300px',
        },
        {
          label: 'Codice prodotti collegati',
          modalLabel: 'Codice prodotti collegati',
          field: 'codiceProdottiCollegati',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true,
        },
        {
          label: 'Compagnia',
          modalLabel: 'Compagnia',
          field: 'compagnia',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          orderable: true,
        },
        {
          label: 'Canale',
          modalLabel: 'Canale',
          field: 'canale',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Distributori',
          modalLabel: 'Distributori',
          field: 'distributori',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Modalità di distribuzione',
          modalLabel: 'Modalità di distribuzione',
          field: 'modalitaDiDistribuzione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Mercato',
          modalLabel: 'Mercato',
          field: 'mercato',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Destinatari',
          modalLabel: 'Destinatari',
          field: 'destinatari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Target market',
          modalLabel: 'Target market',
          field: 'targetMarket',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Descrizione prodotto',
          modalLabel: 'Descrizione prodotto',
          field: 'descrizioneProdotto',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Linea di business',
          modalLabel: 'Linea di business',
          field: 'lineaBusiness',
          width: '300px',
          tag: 'garanzie',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia garanzie Mobilità',
          modalLabel: 'Tipologia garanzie Mobilità',
          field: 'tipologiaGaranzieMobilita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Tipologia garanzie Persona',
          modalLabel: 'Tipologia garanzie Persona',
          field: 'tipologiaGaranziePersona',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia garanzie Casa e Famiglia',
          modalLabel: 'Tipologia garanzie Casa e Famiglia',
          field: 'tipologiaGaranzieCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia garanzie Azienda',
          modalLabel: 'Tipologia garanzie Azienda',
          field: 'tipologiaGaranzieAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia garanzie Professionisti',
          modalLabel: 'Tipologia garanzie Professionisti',
          field: 'tipologiaGaranzieProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Combinazione garanzie - \ntipologia',
          modalLabel: 'Combinazione garanzie - tipologia',
          field: 'combinazioneGaranzieTipologia',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Combinazione garanzie - \ndescrizione',
          modalLabel: 'Combinazione garanzie - descrizione',
          field: 'combinazioneGaranzieDescrizione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Prodotto in commercio',
          modalLabel: 'Prodotto in commercio',
          field: 'prodottoInCommercio',
          width: '300px',
          leftborder: true,
        },
        {
          label: 'Inizio commercializzazione',
          modalLabel: 'Inizio commercializzazione',
          field: 'inizioCommercializzazione',
          width: '300px',
          orderable: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Fine commercializzazione',
          modalLabel: 'Fine commercializzazione',
          field: 'fineCommercializzazione',
          width: '300px',
          orderable: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Edizione DIP aggiuntivo',
          modalLabel: 'Edizione DIP aggiuntivo',
          field: 'edizioneDIPAggiuntivo',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia di assicurazione',
          modalLabel: 'Tipologia di assicurazione',
          field: 'tipologiaDiAssicurazione',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Durata contrattuale',
          modalLabel: 'Durata contrattuale',
          field: 'durataContrattuale',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tacito rinnovo',
          modalLabel: 'Tacito rinnovo',
          field: 'tacitoRinnovo',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Premio - \ntipologia',
          modalLabel: 'Premio - tipologia',
          field: 'premioTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Premio - \ndescrizione',
          modalLabel: 'Premio - descrizione',
          field: 'premioDescrizione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Frazionamento del premio',
          modalLabel: 'Frazionamento del premio',
          field: 'frazionamentoDelPremio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Interessi di frazionamento',
          modalLabel: 'Interessi di frazionamento',
          field: 'interessiDiFrazionamento',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Retrocessione alla distribuzione - \nvalore',
          modalLabel: 'Retrocessione alla distribuzione - valore',
          field: 'retrocessioneAllaDistribuzione',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Retrocessione alla distribuzione - \nspecifiche',
          modalLabel: 'Retrocessione alla distribuzione - specifiche',
          field: 'retrocessioneAllaDistribuzioneSpecifiche',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        // Mobilità
        {
          label: 'Mobilità - \nrischi assicurati',
          modalLabel: 'Rischi assicurati',
          field: 'rischiAssicuratiMobilita',
          width: '300px',
          tag: 'mobilita',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'MOBILITÀ',
          leftborder: true,
        },
        {
          label: 'Infortuni su mezzi sharing',
          modalLabel: 'Infortuni su mezzi sharing',
          field: 'infortuniSuMezziSharing',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Infortuni in bicicletta',
          modalLabel: 'Infortuni in bicicletta',
          field: 'infortuniInBicicletta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Responsabilità civile in bicicletta',
          modalLabel: 'Responsabilità civile in bicicletta',
          field: 'responsabilitaCivileInBicicletta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Responsabilità civile per danni da utilizzo di monopattino elettrico',
          modalLabel: 'Responsabilità civile per danni da utilizzo di monopattino elettrico',
          field: 'responsabilitaCivileMonopattino',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tutela Legale in bicicletta',
          modalLabel: 'Tutela Legale in bicicletta',
          field: 'tutelaLegaleInBicicletta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Furto bicicletta',
          modalLabel: 'Furto bicicletta',
          field: 'furtoBicicletta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Assistenza bicicletta - \ntipologia',
          modalLabel: 'Assistenza bicicletta - tipologia',
          field: 'assistenzaBiciclettaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Assistenza bicicletta - \npeculiarità',
          modalLabel: 'Assistenza bicicletta - peculiarità',
          field: 'assistenzaBiciclettaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Danni causati a terzi in mobilità',
          modalLabel: 'Danni causati a terzi in mobilità',
          field: 'danniCausatiATerziInMobilita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Infortuni su mezzi pubblici',
          modalLabel: 'Infortuni su mezzi pubblici',
          field: 'infortuniSuMezziPubblici',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Infortuni in viaggio',
          modalLabel: 'Infortuni in viaggio',
          field: 'infortuniInViaggio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rimborso spese mediche in viaggio',
          modalLabel: 'Rimborso spese mediche in viaggio',
          field: 'rimborsoSpeseMedicheInViaggio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Furto in viaggio',
          modalLabel: 'Furto in viaggio',
          field: 'furtoInViaggio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Furto bagaglio',
          modalLabel: 'Furto bagaglio',
          field: 'furtoBagaglio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Annullamento viaggio',
          modalLabel: 'Annullamento viaggio',
          field: 'annullamentoViaggio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Assistenza in viaggio - \ntipologia',
          modalLabel: 'Assistenza in viaggio - tipologia',
          field: 'assistenzaInViaggioTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Assistenza in viaggio - \npeculiarità',
          modalLabel: 'Assistenza in viaggio - peculiarità',
          field: 'assistenzaInViaggioPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre garanzie Mobilità',
          modalLabel: 'Altre garanzie Mobilità',
          field: 'altreGaranzieMobilita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        // Persona
        {
          label: 'Persona - \nrischi assicurati',
          modalLabel: 'Rischi assicurati',
          field: 'rischiAssicuratiPersona',
          width: '300px',
          tag: 'persona',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'PERSONA',
          leftborder: true,
        },
        {
          label: 'Morte da infortunio',
          modalLabel: 'Morte da infortunio',
          field: 'morteDaInfortunio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità permanente da infortunio',
          modalLabel: 'Invalidità permanente da infortunio',
          field: 'invaliditaPermanenteDaInfortunio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità temporanea da infortunio',
          modalLabel: 'Inabilità temporanea da infortunio',
          field: 'inabilitaTemporaneaDaInfortunio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Infortunio con indennizzo forfettario',
          modalLabel: 'Infortunio con indennizzo forfettario',
          field: 'infortunioConIndennizzoForfettario',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Morte da malattia',
          modalLabel: 'Morte da malattia',
          field: 'morteDaMalattia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità permanente da malattia',
          modalLabel: 'Invalidità permanente da malattia',
          field: 'invaliditaPermanenteDaMalattia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità temporanea da malattia',
          modalLabel: 'Inabilità temporanea da malattia',
          field: 'inabilitaTemporaneaDaMalattia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Gravi patologie (Malattie gravi)',
          modalLabel: 'Gravi patologie (Malattie gravi)',
          field: 'graviPatologieMalattieGravi',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Cure oncologiche',
          modalLabel: 'Cure oncologiche',
          field: 'cureOncologiche',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Diaria da ricovero da infortunio/malattia',
          modalLabel: 'Diaria da ricovero da infortunio/malattia',
          field: 'diariaDaRicoveroDaInfortunioMalattia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Diaria da convalescenza',
          modalLabel: 'Diaria da convalescenza',
          field: 'diariaDaConvalescenza',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Diaria da immobilizzazione',
          modalLabel: 'Diaria da immobilizzazione',
          field: 'diariaDaImmobilizzazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rimborso spese mediche generiche',
          modalLabel: 'Rimborso spese mediche generiche',
          field: 'rimborsoSpeseMedicheGeneriche',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rimborso spese mediche per grande intervento chirurgico',
          modalLabel: 'Rimborso spese mediche per grande intervento chirurgico',
          field: 'rimborsoSpeseMedichePerGrandeInterventoChirurgico',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rimborso spese mediche per ricovero o intervento chirurgico in genere',
          modalLabel: 'Rimborso spese mediche per ricovero o intervento chirurgico in genere',
          field: 'rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenere',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Visite specialistiche e accertamenti diagnostici',
          modalLabel: 'Visite specialistiche e accertamenti diagnostici',
          field: 'visiteSpecialisticheEAccertamentiDiagnostici',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Prestazioni di alta specializzazione',
          modalLabel: 'Prestazioni di alta specializzazione',
          field: 'prestazioniAltaSpecializzazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Trattamenti fisioterapici rieducativi',
          modalLabel: 'Trattamenti fisioterapici rieducativi',
          field: 'trattamentiFisioterapiciRieducativi',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Intervento chirurgico con indennizzo forfettario',
          modalLabel: 'Intervento chirurgico con indennizzo forfettario',
          field: 'interventoChirurgicoConIndennizzoForfettario',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Gravi ricoveri con indennizzo forfettario',
          modalLabel: 'Gravi ricoveri con indennizzo forfettario',
          field: 'graviRicoveriConIndennizzoForfettario',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Stato di non autosufficienza',
          modalLabel: 'Stato di non autosufficienza',
          field: 'statoDiNonAutosufficienza',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Stato di non autosufficienza temporanea',
          modalLabel: 'Stato di non autosufficienza temporanea',
          field: 'statoDiNonAutosufficienzaTemporanea',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Cure dentarie',
          modalLabel: 'Cure dentarie',
          field: 'cureDentarie',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Assistenza alla persona - \ntipologia',
          modalLabel: 'Assistenza alla persona - tipologia',
          field: 'assistenzaAllaPersonaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Assistenza alla persona - \npeculiarità',
          modalLabel: 'Assistenza alla persona - peculiarità',
          field: 'assistenzaAllaPersonaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Esami di prevenzione (Check-up)',
          modalLabel: 'Esami di prevenzione (Check-up)',
          field: 'esamiDiPrevenzioneCheckUp',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Danni estetici',
          modalLabel: 'Danni estetici',
          field: 'danniEstetici',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Lenti correttive da vista',
          modalLabel: 'Lenti correttive da vista',
          field: 'lentiCorrettiveDaVista',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tutela legale persona - \ntipologia',
          modalLabel: 'Tutela legale persona - tipologia',
          field: 'tutelaLegalePersonaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Tutela legale persona - \npeculiarità',
          modalLabel: 'Tutela legale persona - peculiarità',
          field: 'tutelaLegalePersonaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre garanzie Persona',
          modalLabel: 'Altre garanzie Persona',
          field: 'altreGaranziePersona',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Persona - \nlimiti di età',
          modalLabel: 'Limiti di età',
          field: 'limitiDiEta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Persona - \ncarenze',
          modalLabel: 'Carenze',
          field: 'carenze',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        // Casa e Famiglia
        {
          label: 'Casa e Famiglia - \nrischi assicurati',
          modalLabel: 'Rischi assicurati',
          field: 'rischiAssicuratiCasaEFamiglia',
          width: '300px',
          tag: 'casa_e_famiglia',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'CASA E FAMIGLIA',
          leftborder: true,
        },
        {
          label: 'Incendio - Mutui',
          modalLabel: 'Incendio - Mutui',
          field: 'incendioMutuiCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio - Fabbricato',
          modalLabel: 'Incendio - Fabbricato',
          field: 'incendioFabbricatoCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio - Contenuto',
          modalLabel: 'Incendio - Contenuto',
          field: 'incendioContenutoCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio - Altri rischi - \ntipologia',
          modalLabel: 'Incendio - Altri rischi - tipologia',
          field: 'incendioAltriRischiCasaEFamigliaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Incendio - Altri rischi - \npeculiarità',
          modalLabel: 'Incendio - Altri rischi - peculiarità',
          field: 'incendioAltriRischiCasaEFamigliaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ricorso terzi',
          modalLabel: 'Ricorso terzi',
          field: 'ricorsoTerziCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Rischi catastrofali - Terremoto',
          modalLabel: 'Rischi catastrofali - Terremoto',
          field: 'rischiCatastrofaliTerremotoCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rischi catastrofali - Alluvione/Inondazione',
          modalLabel: 'Rischi catastrofali - Alluvione/Inondazione',
          field: 'rischiCatastrofaliAlluvioneInondazioneCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Proprietà del fabbricato',
          modalLabel: 'RC - Proprietà del fabbricato',
          field: 'RCProprietaDelFabbricatoCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Conduzione',
          modalLabel: 'RC - Conduzione',
          field: 'RCConduzione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Vita privata',
          modalLabel: 'RC - Vita privata',
          field: 'RCVitaPrivata',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - RCO',
          modalLabel: 'RC - RCO',
          field: 'RCRCOCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Altri rischi',
          modalLabel: 'RC - Altri rischi',
          field: 'RCAltriRischiCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Cristalli',
          modalLabel: 'Cristalli',
          field: 'cristalli',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Furto e rapina',
          modalLabel: 'Furto e rapina',
          field: 'furtoERapinaCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Assistenza casa e famiglia - \ntipologia',
          modalLabel: 'Assistenza casa e famiglia - tipologia',
          field: 'assistenzaCasaEFamigliaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Assistenza casa e famiglia - \npeculiarità',
          modalLabel: 'Assistenza casa e famiglia - peculiarità',
          field: 'assistenzaCasaEFamigliaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tutela legale casa e famiglia - \ntipologia',
          modalLabel: 'Tutela legale casa e famiglia - tipologia',
          field: 'tutelaLegaleCasaEFamigliaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Tutela legale casa e famiglia - \npeculiarità',
          modalLabel: 'Tutela legale casa e famiglia - peculiarità',
          field: 'tutelaLegaleCasaEFamigliaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Elettronica',
          modalLabel: 'Elettronica',
          field: 'elettronicaCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Cyber risk/Rischi tecnologici casa e famiglia - \ntipologia',
          modalLabel: 'Cyber risk/Rischi tecnologici casa e famiglia - tipologia',
          field: 'rischiTecnologiciCasaEFamigliaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Cyber risk/Rischi tecnologici casa e famiglia - \npeculiarità',
          modalLabel: 'Cyber risk/Rischi tecnologici casa e famiglia - peculiarità',
          field: 'rischiTecnologiciCasaEFamigliaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Animali domestici - \ntipologia',
          modalLabel: 'Animali domestici - tipologia',
          field: 'animaliDomesticiCasaEFamigliaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Animali domestici - \npeculiarità',
          modalLabel: 'Animali domestici - peculiarità',
          field: 'animaliDomesticiCasaEFamigliaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre garanzie Casa e Famiglia',
          modalLabel: 'Altre garanzie Casa e Famiglia',
          field: 'altreGaranzieCasaEFamiglia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        // Azienda
        {
          label: 'Azienda - \nrischi assicurati',
          modalLabel: 'Rischi assicurati',
          field: 'rischiAssicuratiAzienda',
          width: '300px',
          tag: 'azienda',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'AZIENDA',
          leftborder: true,
        },
        {
          label: 'Incendio - Mutui',
          modalLabel: 'Incendio - Mutui',
          field: 'incendioMutuiAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio - Fabbricato',
          modalLabel: 'Incendio - Fabbricato',
          field: 'incendioFabbricatoAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio - Contenuto',
          modalLabel: 'Incendio - Contenuto',
          field: 'incendioContenutoAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio - Altri rischi - \ntipologia',
          modalLabel: 'Incendio - Altri rischi - tipologia',
          field: 'incendioAltriRischiAziendaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Incendio - Altri rischi - \npeculiarità',
          modalLabel: 'Incendio - Altri rischi - peculiarità',
          field: 'incendioAltriRischiPeculiaritaAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ricorso terzi',
          modalLabel: 'Ricorso terzi',
          field: 'ricorsoTerziAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Rischi catastrofali - Terremoto',
          modalLabel: 'Rischi catastrofali - Terremoto',
          field: 'rischiCatastrofaliTerremotoAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rischi catastrofali - Alluvione/Inondazione',
          modalLabel: 'Rischi catastrofali - Alluvione/Inondazione',
          field: 'rischiCatastrofaliAlluvioneInondazioneAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Proprietà del Fabbricato',
          modalLabel: 'RC - Proprietà del Fabbricato',
          field: 'RCProprietaDelFabbricatoAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - RCT',
          modalLabel: 'RC - RCT',
          field: 'RCRCTAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - RCO',
          modalLabel: 'RC - RCO',
          field: 'RCRCOAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Altri rischi - \ntipologia',
          modalLabel: 'RC - Altri rischi - tipologia',
          field: 'RCAltriRischiAziendaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC - Altri rischi - \npeculiarità',
          modalLabel: 'RC - Altri rischi - peculiarità',
          field: 'RCAltriRischiPeculiaritaAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Furto e rapina',
          modalLabel: 'Furto e rapina',
          field: 'furtoERapinaAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },      
          leftborder: true,    
        },
        {
          label: 'Assistenza azienda - \ntipologia',
          modalLabel: 'Assistenza azienda - tipologia',
          field: 'assistenzaAziendaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Assistenza azienda - \npeculiarità',
          modalLabel: 'Assistenza azienda - peculiarità',
          field: 'assistenzaAziendaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tutela legale azienda - \ntipologia',
          modalLabel: 'Tutela legale azienda - tipologia',
          field: 'tutelaLegaleAziendaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Tutela legale azienda - \npeculiarità',
          modalLabel: 'Tutela legale azienda - peculiarità',
          field: 'tutelaLegaleAziendaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Elettronica',
          modalLabel: 'Elettronica',
          field: 'elettronicaAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Danni indiretti',
          modalLabel: 'Danni indiretti',
          field: 'danniIndirettiAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Vetri e insegne',
          modalLabel: 'Vetri e insegne',
          field: 'vetriEInsegneAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Cyber risk/Rischi tecnologici azienda - \ntipologia',
          modalLabel: 'Cyber risk/Rischi tecnologici azienda - tipologia',
          field: 'rischiTecnologiciAziendaTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Cyber risk/Rischi tecnologici azienda - \npeculiarità',
          modalLabel: 'Cyber risk/Rischi tecnologici azienda - peculiarità',
          field: 'rischiTecnologiciAziendaPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre garanzie Azienda',
          modalLabel: 'Altre garanzie Azienda',
          field: 'altreGaranzieAzienda',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        // Professionisti
        {
          label: 'Professionisti - \nrischi assicurati',
          modalLabel: 'Rischi assicurati',
          field: 'rischiAssicuratiProfessionisti',
          width: '300px',
          tag: 'professionisti',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'PROFESSIONISTI',
          leftborder: true,
        },
        {
          label: 'RC professionale (area tecnica)',
          modalLabel: 'RC professionale (area tecnica)',
          field: 'RCProfAreaTecnica',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC professionale (area tecnica) - Altri rischi - \ntipologia',
          modalLabel: 'RC professionale (area tecnica) - Altri rischi - tipologia',
          field: 'RCProfAreaTecnicaAltriRischiTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC professionale (area tecnica) - Altri rischi - \npeculiarità',
          modalLabel: 'RC professionale (area tecnica) - Altri rischi - peculiarità',
          field: 'RCProfAreaTecnicaAltriRischiPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC professionale (area economica-giuridica)',
          modalLabel: 'RC professionale (area economica-giuridica)',
          field: 'RCProfAreaEconomicaGiuridica',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC professionale (area economica-giuridica)  - Altri rischi - \ntipologia',
          modalLabel: 'RC professionale (area economica-giuridica)  - Altri rischi - tipologia',
          field: 'RCProfAreaEconomicaGiuridicaAltriRischiTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC professionale (area economica-giuridica)  - Altri rischi - \npeculiarità',
          modalLabel: 'RC professionale (area economica-giuridica)  - Altri rischi - peculiarità',
          field: 'RCProfAreaEconomicaGiuridicaAltriRischiPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC professionale (area medica)',
          modalLabel: 'RC professionale (area medica)',
          field: 'RCProfAreaMedica',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC professionale (area medica)  - Altri rischi - \ntipologia',
          modalLabel: 'RC professionale (area medica)  - Altri rischi - tipologia',
          field: 'RCProfAreaMedicaAltriRischiTipologia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC professionale (area medica)  - Altri rischi - \npeculiarità',
          modalLabel: 'RC professionale (area medica)  - Altri rischi - peculiarità',
          field: 'RCProfAreaMedicaAltriRischiPeculiarita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC professionale (altra area)',
          modalLabel: 'RC professionale (altra area)',
          field: 'RCProfAltraArea',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'RC - RCT',
          modalLabel: 'RC - RCT',
          field: 'RCRCTProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - RCO',
          modalLabel: 'RC - RCO',
          field: 'RCRCOProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'RC - Proprietà e conduzione',
          modalLabel: 'RC - Proprietà e conduzione',
          field: 'RCProprietaEConduzione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Assistenza professionisti',
          modalLabel: 'Assistenza professionisti',
          field: 'assistenzaProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tutela legale professionisti',
          modalLabel: 'Tutela legale professionisti',
          field: 'tutelaLegaleProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Cyber risk/Rischi tecnologici professionisti',
          modalLabel: 'Cyber risk/Rischi tecnologici professionisti',
          field: 'rischiTecnologiciProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },          
        },
        {
          label: 'Infortuni',
          modalLabel: 'Infortuni',
          field: 'infortuni',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Incendio e danni alla proprietà',
          modalLabel: 'Incendio e danni alla proprietà',
          field: 'incendioEDanniAllaProprieta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Furto e rapina',
          modalLabel: 'Furto e rapina',
          field: 'furtoERapinaProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Elettronica',
          modalLabel: 'Elettronica',
          field: 'elettronicaProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Vetri e cristalli',
          modalLabel: 'Vetri e cristalli',
          field: 'vetriECristalliProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre garanzie Professionisti',
          modalLabel: 'Altre garanzie Professionisti',
          field: 'altreGaranzieProfessionisti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        // Innovazione
        {
          label: 'Innovazione',
          modalLabel: 'Innovazione',
          field: 'innovazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
          sectionName: '',
        },
        // Note
        {
          label: 'Note',
          modalLabel: 'Note',
          field: 'note',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: '',
        },
      ],
      tags: [
        { tag: 'caratteristiche_generali', label: 'Caratteristiche generali' },
        { tag: 'garanzie', label: 'Garanzie' },
        { tag: 'mobilita', label: 'Mobilità' },
        { tag: 'persona', label: 'Persona' },
        { tag: 'casa_e_famiglia', label: 'Casa e Famiglia' },
        { tag: 'azienda', label: 'Azienda' },
        { tag: 'professionisti', label: 'Professionisti' },
      ],
      headers: {
        supergroups: [
          {
            key: 0,
            label: '',
            colspan: 16,
          },
          {
            key: 1,
            label: 'Tipologia garanzie',
            colspan: 5,
          },
          {
            key: 2,
            label: 'Combinazione garanzie',
            colspan: 2,
          },
          {
            key: 3,
            label: '',
            colspan: 7,
            leftborder: true,
          },
          {
            key: 4,
            label: 'Premio',
            colspan: 2,
          },
          {
            key: 5,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 6,
            label: 'Retrocessione alla\ndistribuzione',
            colspan: 2,
          },
          {
            key: 7,
            label: 'Mobilità',
            colspan: 19,
          },
          {
            key: 8,
            label: 'Persona',
            colspan: 34,
          },
          {
            key: 9,
            label: 'Casa e famiglia',
            colspan: 26,
          },
          {
            key: 10,
            label: 'Azienda',
            colspan: 25,
          },
          {
            key: 11,
            label: 'Professionisti',
            colspan: 23,
          },
          {
            key: 12,
            label: '',
            colspan: 2,
            leftborder: true,
          },
        ],
        groups: [
          {
            key: 0,
            label: '',
            colspan: 16,
          },
          {
            key: 1,
            label: '',
            colspan: 5,
            leftborder: true,
          },
          {
            key: 2,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 3,
            label: '',
            colspan: 7,
            leftborder: true,
          },
          {
            key: 4,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 5,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 6,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 7,
            label: '',
            colspan: 7,
            leftborder: true,
          },
          {
            key: 8,
            label: 'Assistenza bicicletta',
            colspan: 2,
          },
          {
            key: 9,
            label: '',
            colspan: 7,
            leftborder: true,
          },
          {
            key: 10,
            label: 'Assistenza viaggio',
            colspan: 2,
          },
          {
            key: 11,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 12,
            label: '',
            colspan: 24,
            leftborder: true,
          },
          {
            key: 13,
            label: 'Assistenza\nalla persona',
            colspan: 2,
          },
          {
            key: 14,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 15,
            label: 'Tutela legale\npersona',
            colspan: 2,
          },
          {
            key: 16,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 17,
            label: '',
            colspan: 4,
            leftborder: true,
          },
          {
            key: 18,
            label: 'Incendio - Altri rischi',
            colspan: 2,
          },
          {
            key: 19,
            label: '',
            colspan: 10,
            leftborder: true,
          },
          {
            key: 20,
            label: 'Assistenza\nCasa e famiglia',
            colspan: 2,
          },
          {
            key: 21,
            label: 'Tutela legale\nCasa e famiglia',
            colspan: 2,
          },
          {
            key: 22,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 23,
            label: 'Cyber risk\nRischi tecnologici\nCasa e famiglia',
            colspan: 2,
          },
          {
            key: 24,
            label: 'Animali domestici',
            colspan: 2,
          },
          {
            key: 25,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 26,
            label: '',
            colspan: 4,
            leftborder: true,
          },
          {
            key: 27,
            label: 'Incendio - Altri rischi',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 28,
            label: '',
            colspan: 6,
            leftborder: true,
          },
          {
            key: 29,
            label: 'RC - Altri rischi',
            colspan: 2,
          },
          {
            key: 30,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 31,
            label: 'Assistenza\nAzienda',
            colspan: 2,
          },
          {
            key: 32,
            label: 'Tutela legale\nAzienda',
            colspan: 2,
          },
          {
            key: 33,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 34,
            label: 'Cyber risk\nRischi tecnologici\nAzienda',
            colspan: 2,
          },
          {
            key: 35,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 36,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 37,
            label: 'RC Professionale\nArea tecnica\nAltri rischi',
            colspan: 2,
          },
          {
            key: 38,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 39,
            label: 'RC Professionale\nArea economica-giuridica\nAltri rischi',
            colspan: 2,
          },
          {
            key: 40,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 41,
            label: 'RC Professionale\nArea medica\nAltri rischi',
            colspan: 2,
          },
          {
            key: 42,
            label: '',
            colspan: 13,
            leftborder: true,
          },
          {
            key: 43,
            label: '',
            colspan: 2,
            leftborder: true,
          },
        ],
      },
      filtroRicerca: {
        prodottoCompleto: null,
        compagnia: [] as any,
        prodotto: [] as any,
        canale: [] as any,
        distributori: [] as any,
        modDistribuzione: [] as any,
        lineaBusiness: [] as any,
        mercato: undefined,
        tipologiaGaranzieMobilita: [] as any,
        tipologiaGaranziePersona: [] as any,
        tipologiaGaranzieCasaEFamiglia: [] as any,
        tipologiaGaranzieAzienda: [] as any,
        tipologiaGaranzieProfessionisti: [] as any,
        prodottoInCommercio: null,
        inizioCommercializzazioneDaDate: Date,
        inizioCommercializzazioneADate: Date,
        fineCommercializzazioneDaDate: Date,
        fineCommercializzazioneADate: Date,
        inizioCommercializzazioneDa: String,
        inizioCommercializzazioneA: String,
        fineCommercializzazioneDa: String,
        fineCommercializzazioneA: String,
        tipoAssicurazione: undefined,
        premioTipologia: [] as any,
      },
      operationToConfirm: "",
      msgError: "",
      msgSuccess: "",
      msgConfirmOperation: "",
      it,
      ...data,
      ...properties,
      propertyTypes,
      prodottiOptions: [] as any,
      distributoriOptions: [] as any,
      compagnieOptions: [] as any,
      ND: "n.d.",
      product: {} as any,
      productName: "",
      scrollTables: null as any,
      selectAll: false,
    };
  },

  methods: {
    storeFilter: function(filter: any) {
      var f: Filter = {
        id: FILTER_KEY,
        payload: filter !== undefined ? filter : this.filtroRicerca,
        changedFields: {},
        viewState: {},
      }
      this.$store.dispatch('filters/set', f);
    },
    getStoredFilter: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.payload;
    },
    resetFilterOptions: async function() {
      const vm = this as any;

      vm.filterOptions.prodottoCompleto = vm.yesNoOptions;
      vm.filterOptions.prodotto = vm.prodottiOptions;
      vm.filterOptions.compagnia = vm.compagnieOptions;
      vm.filterOptions.mercato = vm.mercatoOptions;
      vm.filterOptions.canale = vm.canaleOptions;
      vm.filterOptions.distributori = vm.distributoriOptions;
      vm.filterOptions.modDistribuzione = vm.modDistribuzioneOptions;
      vm.filterOptions.lineaBusiness = vm.lineaBusinessOptions;
      vm.filterOptions.prodottoInCommercio = vm.yesNoOptions;
      vm.filterOptions.tipologiaGaranzieMobilita = vm.tipologiaGaranzieMobilitaOptions;
      vm.filterOptions.tipologiaGaranziePersona = vm.tipologiaGaranziePersonaOptions;
      vm.filterOptions.tipologiaGaranzieCasaEFamiglia = vm.tipologiaGaranzieCasaEFamigliaOptions;
      vm.filterOptions.tipologiaGaranzieAzienda = vm.tipologiaGaranzieAziendaOptions;
      vm.filterOptions.tipologiaGaranzieProfessionisti = vm.tipologiaGaranzieProfessionistiOptions;
      vm.filterOptions.tipoAssicurazione = vm.tipoAssicurazioneOptions;
      vm.filterOptions.premioTipologia = vm.premioTipologiaOptions;
    },
    emptyNoDynamicFiltroRicerca: async function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
      vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.fineCommercializzazioneADate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
      vm.filtroRicerca.inizioCommercializzazioneA = undefined;
      vm.filtroRicerca.fineCommercializzazioneDa = undefined;
      vm.filtroRicerca.fineCommercializzazioneA = undefined;
    },
    emptyFilterOptions: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('prodottoCompleto') ||
          vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
        vm.filterOptions.prodottoCompleto = []; 
      }
      if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filterOptions.prodotto = [];
      }
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filterOptions.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filterOptions.mercato = [];
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filterOptions.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filterOptions.distributori = [];
      }
      if (!vm.changedFilterFields.includes('modDistribuzione') ||
          vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
        vm.filterOptions.modDistribuzione = [];
      }
      if (!vm.changedFilterFields.includes('lineaBusiness') ||
          vm.changedFilterFields.indexOf('lineaBusiness') > indexOfChangedField) {
        vm.filterOptions.lineaBusiness = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filterOptions.prodottoInCommercio = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieMobilita') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieMobilita') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranzieMobilita = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranziePersona') ||
          vm.changedFilterFields.indexOf('tipologiaGaranziePersona') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranziePersona = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieCasaEFamiglia') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieCasaEFamiglia') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranzieCasaEFamiglia = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieAzienda') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieAzienda') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranzieAzienda = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieProfessionisti') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieProfessionisti') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranzieProfessionisti = [];
      }
      if (!vm.changedFilterFields.includes('tipoAssicurazione') ||
          vm.changedFilterFields.indexOf('tipoAssicurazione') > indexOfChangedField) {
        vm.filterOptions.tipoAssicurazione = [];
      }
      if (!vm.changedFilterFields.includes('premioTipologia') ||
          vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
        vm.filterOptions.premioTipologia = [];
      }
    },
    emptyFiltroRicerca: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('prodottoCompleto') ||
          vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
        vm.filtroRicerca.prodottoCompleto = null;
      }
      if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filtroRicerca.prodotto = [];
      }
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filtroRicerca.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filtroRicerca.mercato = undefined;
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filtroRicerca.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filtroRicerca.distributori = [];
      }
      if (!vm.changedFilterFields.includes('modDistribuzione') ||
          vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
        vm.filtroRicerca.modDistribuzione = [];
      }
      if (!vm.changedFilterFields.includes('lineaBusiness') ||
          vm.changedFilterFields.indexOf('lineaBusiness') > indexOfChangedField) {
        vm.filtroRicerca.lineaBusiness = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filtroRicerca.prodottoInCommercio = null;
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieMobilita') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieMobilita') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranzieMobilita = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranziePersona') ||
          vm.changedFilterFields.indexOf('tipologiaGaranziePersona') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranziePersona = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieCasaEFamiglia') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieCasaEFamiglia') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranzieCasaEFamiglia = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieAzienda') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieAzienda') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranzieAzienda = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzieProfessionisti') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzieProfessionisti') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranzieProfessionisti = [];
      }
      if (!vm.changedFilterFields.includes('tipoAssicurazione') ||
          vm.changedFilterFields.indexOf('tipoAssicurazione') > indexOfChangedField) {
        vm.filtroRicerca.tipoAssicurazione = undefined;
      }
      if (!vm.changedFilterFields.includes('premioTipologia') ||
          vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
        vm.filtroRicerca.premioTipologia = [];
      }
    },
    emptyChangedFilterFields() {
      const vm = this as any;

      vm.changedFilterFields = [];
    },
    resetFilterOptionsAndEmptyFiltroRicerca() {
      const vm = this as any;

      vm.resetFilterOptions();
      vm.emptyNoDynamicFiltroRicerca();
      vm.emptyFiltroRicerca(-1);
      vm.emptyChangedFilterFields();
      vm.storeFilter();
    },
    repopulateFiltersOptionsChangedCompagnia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('compagnia');
    },
    repopulateFiltersOptionsChangedProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('prodotto');
    },
    repopulateFiltersOptionsChangedDistributori: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('distributori');
    },
    repopulateFiltersOptionsChangedCanale: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('canale');
    },
    repopulateFiltersOptionsChangedModDistribuzione: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('modDistribuzione');
    },
    repopulateFiltersOptionsChangedLineaBusiness: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('lineaBusiness');
    },    
    repopulateFiltersOptionsChangedTipologiaGaranzieMobilita: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranzieMobilita');
    },
    repopulateFiltersOptionsChangedTipologiaGaranziePersona: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranziePersona');
    },
    repopulateFiltersOptionsChangedTipologiaGaranzieCasaEFamiglia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranzieCasaEFamiglia');
    },
    repopulateFiltersOptionsChangedTipologiaGaranzieAzienda: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranzieAzienda');
    },
    repopulateFiltersOptionsChangedTipologiaGaranzieProfessionisti: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranzieProfessionisti');
    },
    repopulateFiltersOptionsChangedPremioTipologia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('premioTipologia');
    },
    repopulateFiltersOptions: async function(changedFieldName: string) {
      const vm = this as any;

      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean

      // mantenere l'ordine!
      if (!vm.changedFilterFields.includes(changedFieldName)) {
        vm.changedFilterFields.push(changedFieldName);
      }
      const indexOfChangedField = vm.changedFilterFields.indexOf(changedFieldName)
      vm.emptyFilterOptions(indexOfChangedField);
      vm.emptyFiltroRicerca(indexOfChangedField);
      if (indexOfChangedField + 1 < vm.changedFilterFields.length) {
        vm.changedFilterFields.splice(indexOfChangedField+1, (vm.changedFilterFields.length-indexOfChangedField+1));
      }
      if (vm.filtroRicerca[changedFieldName] === undefined ||
          vm.filtroRicerca[changedFieldName] === null ||
          vm.filtroRicerca[changedFieldName].length == 0) {
        vm.changedFilterFields.pop();
      }
      //console.log(JSON.stringify(vm.filtroRicerca[changedFieldName]));
      //console.log(indexOfChangedField  + " " + changedFieldName + " vm.changedFilterFields " + JSON.stringify(vm.changedFilterFields));

      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {

              // Prodotto completo
              if (!vm.changedFilterFields.includes('prodottoCompleto') ||
                  vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
                let filterProdottoCompletoOption = { code : vm.listaProdottiCensiti[i].completed , value : (vm.listaProdottiCensiti[i].completed ? "Sì" : "No" ) };
                vm.pushOptionValue(filterProdottoCompletoOption,vm.filterOptions.prodottoCompleto);
              }

              // Prodotto
              if (!vm.changedFilterFields.includes('prodotto') ||
                  vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
                let filterProdottoOption = vm.listaProdottiCensiti[i].properties[0];
                vm.pushOptionValueProdotto(filterProdottoOption,vm.filterOptions.prodotto);
              }

              // Compagnia
              if (!vm.changedFilterFields.includes('compagnia') ||
                  vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
                let filterCompagniaOption = vm.listaProdottiCensiti[i].properties[3];
                vm.pushOptionValue(filterCompagniaOption,vm.filterOptions.compagnia);
              }

              // Mercato
              if (!vm.changedFilterFields.includes('mercato') ||
                  vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
                let filterMercatoOption = vm.listaProdottiCensiti[i].properties[7];
                vm.pushOptionValues(filterMercatoOption,vm.filterOptions.mercato);
              }

              // Canale
              if (!vm.changedFilterFields.includes('canale') ||
                  vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
                let filterCanaleOption = vm.listaProdottiCensiti[i].properties[4];
                vm.pushOptionValues(filterCanaleOption,vm.filterOptions.canale);
              }

              // Distributori
              if (!vm.changedFilterFields.includes('distributori') ||
                  vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
                let filterDistributoriOption = vm.listaProdottiCensiti[i].properties[5];
                vm.pushOptionStringList(filterDistributoriOption,vm.filterOptions.distributori,'distributori');
              }

              // Modalità di distribuzione
              if (!vm.changedFilterFields.includes('modDistribuzione') ||
                  vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
                let filterModDistribuzioneOption = vm.listaProdottiCensiti[i].properties[6];
                vm.pushOptionValues(filterModDistribuzioneOption,vm.filterOptions.modDistribuzione);
              }

              // Linea business
              if (!vm.changedFilterFields.includes('lineaBusiness') ||
                  vm.changedFilterFields.indexOf('lineaBusiness') > indexOfChangedField) {
                let filterLineaBusinessOption = vm.listaProdottiCensiti[i].properties[11];
                vm.pushOptionValues(filterLineaBusinessOption,vm.filterOptions.lineaBusiness);
              }

              // Prodotto in commercio
              if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
                  vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
                let filterProdottoInCommercioOption = { code : (vm.listaProdottiCensiti[i].properties[19].code == "16.1" ? true : false) , value : vm.listaProdottiCensiti[i].properties[19].value };
                vm.pushOptionValue(filterProdottoInCommercioOption,vm.filterOptions.prodottoInCommercio);
              }

              // Tipologia Garanzie Mobilità
              if (!vm.changedFilterFields.includes('tipologiaGaranzieMobilita') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranzieMobilita') > indexOfChangedField) {
                let filterTipologiaGaranzieMobilitaOption = vm.listaProdottiCensiti[i].properties[12];
                vm.pushOptionValues(filterTipologiaGaranzieMobilitaOption,vm.filterOptions.tipologiaGaranzieMobilita);
              }

              // Tipologia Garanzie Persona
              if (!vm.changedFilterFields.includes('tipologiaGaranziePersona') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranziePersona') > indexOfChangedField) {
                let filterTipologiaGaranziePersonaOption = vm.listaProdottiCensiti[i].properties[13];
                vm.pushOptionValues(filterTipologiaGaranziePersonaOption,vm.filterOptions.tipologiaGaranziePersona);
              }

              // Tipologia Garanzie Casa e Famiglia
              if (!vm.changedFilterFields.includes('tipologiaGaranzieCasaEFamiglia') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranzieCasaEFamiglia') > indexOfChangedField) {
                let filterTipologiaGaranzieCasaEFamigliaOption = vm.listaProdottiCensiti[i].properties[14];
                vm.pushOptionValues(filterTipologiaGaranzieCasaEFamigliaOption,vm.filterOptions.tipologiaGaranzieCasaEFamiglia);
              }

              // Tipologia Garanzie Azienda
              if (!vm.changedFilterFields.includes('tipologiaGaranzieAzienda') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranzieAzienda') > indexOfChangedField) {
                let filterTipologiaGaranzieAziendaOption = vm.listaProdottiCensiti[i].properties[15];
                vm.pushOptionValues(filterTipologiaGaranzieAziendaOption,vm.filterOptions.tipologiaGaranzieAzienda);
              }

              // Tipologia Garanzie Professionisti
              if (!vm.changedFilterFields.includes('tipologiaGaranzieProfessionisti') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranzieProfessionisti') > indexOfChangedField) {
                let filterTipologiaGaranzieProfessionistiOption = vm.listaProdottiCensiti[i].properties[16];
                vm.pushOptionValues(filterTipologiaGaranzieProfessionistiOption,vm.filterOptions.tipologiaGaranzieProfessionisti);
              }

              // Tipologia di assicurazione
              if (!vm.changedFilterFields.includes('tipoAssicurazione') ||
                  vm.changedFilterFields.indexOf('tipoAssicurazione') > indexOfChangedField) {
                let filterTipoAssicurazioneOption = vm.listaProdottiCensiti[i].properties[23];
                vm.pushOptionValue(filterTipoAssicurazioneOption,vm.filterOptions.tipoAssicurazione);
              }

              // Tipologia premio
              if (!vm.changedFilterFields.includes('premioTipologia') ||
                  vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
                let filterPremioTipologiaOption = vm.listaProdottiCensiti[i].properties[26];
                vm.pushOptionValues(filterPremioTipologiaOption,vm.filterOptions.premioTipologia);
              }
            }
          }


          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    retrieveProductsList: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean
      vm.listaProdottiCensitiForTable = []; //clean

      vm.setDatePropertiesValue();

      if (vm.$props.filters == undefined) {
        vm.storeFilter();
      }
      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          vm.listaProdottiCensiti.sort(function(a: any, b: any) {
            const nameA = a.properties[0].value.toUpperCase(); // ignora maiuscole e minuscole
            const nameB = b.properties[0].value.toUpperCase(); // ignora maiuscole e minuscole
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            const codeA = a.productCode; // ignora maiuscole e minuscole
            const codeB = b.productCode; // ignora maiuscole e minuscole
            if (codeA < codeB) {
              return -1;
            }
            if (codeA > codeB) {
              return 1;
            }

            return 0;
          });

          const prodotti = vm.listaProdottiCensiti.length;
          if (prodotti > vm.itemsPerPage) {
            const p = prodotti / vm.itemsPerPage;
            vm.totPages = Math.floor(p);
            if (p > vm.totPages) {
              vm.totPages += 1;
            }
          } else {
            vm.totPages = 1;
          }
          vm.needsPagination = vm.totPages > 1;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {
              let prop = 0;
              let obj = {} as any;
              obj.id = i;
              obj.isSelected = false;
              obj.isToModify = vm.isAdmin();
              obj.prodottoCompleto = vm.listaProdottiCensiti[i].completed;
              obj.productId = vm.listaProdottiCensiti[i].productId;
              obj.productCode = vm.listaProdottiCensiti[i].productCode;
              obj.prodotto = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.piuTariffeProdotto = vm.listaProdottiCensiti[i].properties[prop++].value;
              obj.codiceProdottiCollegati = vm.listaProdottiCensiti[i].properties[prop++].value;
              obj.compagnia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.canale = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.distributori = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.modalitaDiDistribuzione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.mercato = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.destinatari = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.targetMarket = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.descrizioneProdotto = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.lineaBusiness = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tipologiaGaranzieMobilita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tipologiaGaranziePersona = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tipologiaGaranzieCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tipologiaGaranzieAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tipologiaGaranzieProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.combinazioneGaranzieTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.combinazioneGaranzieDescrizione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.prodottoInCommercio = vm.listaProdottiCensiti[i].properties[prop++].value;
              obj.inizioCommercializzazione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.fineCommercializzazione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.edizioneDIPAggiuntivo = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tipologiaDiAssicurazione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.durataContrattuale = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tacitoRinnovo = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.premioTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.premioDescrizione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.frazionamentoDelPremio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.interessiDiFrazionamento = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.retrocessioneAllaDistribuzione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.retrocessioneAllaDistribuzioneSpecifiche = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // Mobilità
              obj.rischiAssicuratiMobilita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.infortuniSuMezziSharing = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.infortuniInBicicletta = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.responsabilitaCivileInBicicletta = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.responsabilitaCivileMonopattino = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegaleInBicicletta = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.furtoBicicletta = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaBiciclettaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaBiciclettaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.danniCausatiATerziInMobilita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.infortuniSuMezziPubblici = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.infortuniInViaggio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rimborsoSpeseMedicheInViaggio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.furtoInViaggio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.furtoBagaglio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.annullamentoViaggio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaInViaggioTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaInViaggioPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.altreGaranzieMobilita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // Persona
              obj.rischiAssicuratiPersona = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.morteDaInfortunio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.invaliditaPermanenteDaInfortunio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.inabilitaTemporaneaDaInfortunio = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.infortunioConIndennizzoForfettario = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.morteDaMalattia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.invaliditaPermanenteDaMalattia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.inabilitaTemporaneaDaMalattia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.graviPatologieMalattieGravi = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.cureOncologiche = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.diariaDaRicoveroDaInfortunioMalattia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.diariaDaConvalescenza = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.diariaDaImmobilizzazione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rimborsoSpeseMedicheGeneriche = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rimborsoSpeseMedichePerGrandeInterventoChirurgico = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenere = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.visiteSpecialisticheEAccertamentiDiagnostici = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.prestazioniAltaSpecializzazione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.trattamentiFisioterapiciRieducativi = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.interventoChirurgicoConIndennizzoForfettario = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.graviRicoveriConIndennizzoForfettario = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.statoDiNonAutosufficienza = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.statoDiNonAutosufficienzaTemporanea = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.cureDentarie = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaAllaPersonaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaAllaPersonaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.esamiDiPrevenzioneCheckUp = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.danniEstetici = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.lentiCorrettiveDaVista = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegalePersonaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegalePersonaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.altreGaranziePersona = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.limitiDiEta = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.carenze = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // Casa e Famiglia
              obj.rischiAssicuratiCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioMutuiCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioFabbricatoCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioContenutoCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioAltriRischiCasaEFamigliaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioAltriRischiCasaEFamigliaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.ricorsoTerziCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiCatastrofaliTerremotoCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiCatastrofaliAlluvioneInondazioneCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProprietaDelFabbricatoCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCConduzione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCVitaPrivata = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCRCOCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCAltriRischiCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.cristalli = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.furtoERapinaCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaCasaEFamigliaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaCasaEFamigliaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegaleCasaEFamigliaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegaleCasaEFamigliaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.elettronicaCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiTecnologiciCasaEFamigliaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiTecnologiciCasaEFamigliaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.animaliDomesticiCasaEFamigliaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.animaliDomesticiCasaEFamigliaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.altreGaranzieCasaEFamiglia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // Azienda
              obj.rischiAssicuratiAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioMutuiAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioFabbricatoAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioContenutoAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioAltriRischiAziendaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioAltriRischiPeculiaritaAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.ricorsoTerziAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiCatastrofaliTerremotoAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiCatastrofaliAlluvioneInondazioneAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProprietaDelFabbricatoAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCRCTAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCRCOAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCAltriRischiAziendaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCAltriRischiPeculiaritaAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.furtoERapinaAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaAziendaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaAziendaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegaleAziendaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegaleAziendaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.elettronicaAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.danniIndirettiAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.vetriEInsegneAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiTecnologiciAziendaTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiTecnologiciAziendaPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.altreGaranzieAzienda = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // Professionisti
              obj.rischiAssicuratiProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaTecnica = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaTecnicaAltriRischiTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaTecnicaAltriRischiPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaEconomicaGiuridica = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaEconomicaGiuridicaAltriRischiTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaEconomicaGiuridicaAltriRischiPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaMedica = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaMedicaAltriRischiTipologia = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAreaMedicaAltriRischiPeculiarita = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProfAltraArea = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCRCTProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCRCOProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.RCProprietaEConduzione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.assistenzaProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.tutelaLegaleProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.rischiTecnologiciProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.infortuni = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.incendioEDanniAllaProprieta = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.furtoERapinaProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.elettronicaProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.vetriECristalliProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              obj.altreGaranzieProfessionisti = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // innovazione
              obj.innovazione = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);
              // Note
              obj.note = vm.printVersatileValues(vm.listaProdottiCensiti[i].properties[prop++]);

              vm.listaProdottiCensitiForTable.push(obj);
            }
          }

          vm.listaProdottiCensitiPaginati = [];
          for (let i = 0; i < vm.totPages; i++) {
            const s = vm.itemsPerPage * i;
            const e = vm.itemsPerPage * (i + 1);
            const sliced = vm.listaProdottiCensitiForTable.slice(s, e);
            vm.listaProdottiCensitiPaginati.push(sliced);
          }

          vm.listaProdottiCensitiCurrent = vm.listaProdottiCensitiPaginati[0];

          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getPropertyValues: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      const serviceCallReturnValue = await requestService.getPropertyValues(vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.prodottiOptions = result.prodotti;
          vm.distributoriOptions = result.distributori;
          vm.compagnieOptions = result.compagnie;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },    
    inizializzaFiltroRicerca: function() {
      const vm = this as any;

      let filter = this.$props.filters;
      if (filter == undefined) {
        filter = vm.getStoredFilter();
      }

      if (filter == undefined) {
        vm.filtroRicerca.prodottoCompleto = null;
        vm.filtroRicerca.compagnia = [] as any;
        vm.filtroRicerca.prodotto = [] as any;
        vm.filtroRicerca.canale = [] as any;
        vm.filtroRicerca.distributori = [] as any;
        vm.filtroRicerca.modDistribuzione = [] as any;
        vm.filtroRicerca.lineaBusiness = [] as any;
        vm.filtroRicerca.mercato = undefined;
        vm.filtroRicerca.tipologiaGaranzieMobilita = [] as any;
        vm.filtroRicerca.tipologiaGaranziePersona = [] as any;
        vm.filtroRicerca.tipologiaGaranzieCasaEFamiglia = [] as any;
        vm.filtroRicerca.tipologiaGaranzieAzienda = [] as any;
        vm.filtroRicerca.tipologiaGaranzieProfessionisti = [] as any;
        vm.filtroRicerca.prodottoInCommercio = null;
        vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
        vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.fineCommercializzazioneADate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
        vm.filtroRicerca.inizioCommercializzazioneA = undefined;
        vm.filtroRicerca.fineCommercializzazioneDa = undefined;
        vm.filtroRicerca.fineCommercializzazioneA = undefined;
        vm.filtroRicerca.prodottoCompleto = null;
        vm.filtroRicerca.tipoAssicurazione = undefined;
        vm.filtroRicerca.premioTipologia = [] as any;
      } else {
        vm.filtroRicerca = filter;
      }
    },
    pushOptionValue(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value)) {
        filter.push({ code : filterOptionToInsert.code , description : filterOptionToInsert.value });
      }
    },
    pushOptionValueProdotto(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value)) {
        filter.push({ code : filterOptionToInsert.code + "_" + filterOptionToInsert.value , description : filterOptionToInsert.value });
      }
    },
    pushOptionValues(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.values.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.code == v.code && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          filter.push({ code : v.code , description : v.description })
        }
      });
    },
    pushOptionStringList(filterOptionToInsert: any, filter: any, fieldName: string) {
      const vm = this as any;

      filterOptionToInsert.stringList.forEach((s: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.description == s.value) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent && !vm.isEmptyOrSpaces(s.value)) {
          let index = filter.length;
          filter.push({ code : categories.CPI_PPI + "-" + fieldName + "-" + index, description : s.value });
        }
      });
    },
    homeProdotti: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      if (vm.fromDashboard) {
        vm.dashboardDanniNonAuto();
      } else {
        vm.$router.go(-1);
      }
    },
    dashboardDanniNonAuto: function() {
      const vm = this as any;
      const isAdvanced = vm.isAdvanced() || vm.isAdmin();
      if (!isAdvanced || vm.noDashboard()) { return; }
      vm.$router.push({ name: 'dashboard-danni-non-auto', params: {user: vm.loggedUser, fromDatabase: true}});
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    setIsSelected: function(index: number) {
      const vm = this as any;
      vm.listaProdottiCensitiForTable[index].isSelected = !vm.listaProdottiCensitiForTable[index].isSelected;
      if (!vm.listaProdottiCensitiForTable[index].isSelected) {
        vm.selectAll = false;
        jquery('#isSelectedAll').prop('checked', false);
      }
    },
    setIsSelectedAll: function() {
      const vm = this as any;
      vm.selectAll = !vm.selectAll;
      vm.listaProdottiCensitiForTable.forEach(function (c: any) {
        c.isSelected = vm.selectAll;
      });
      jquery('.selectProd').prop('checked', vm.selectAll);
    },
    isCompleted: function(index: number) {
      const vm = this as any;
      return vm.listaProdottiCensitiForTable[index].prodottoCompleto ? "Sì" : "No";
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneDaDate);
      vm.filtroRicerca.inizioCommercializzazioneA = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneADate);
      vm.filtroRicerca.fineCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneDaDate);
      vm.filtroRicerca.fineCommercializzazioneA = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneADate);
    },
    exportExcel: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let csvName = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractXlsx(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
            return response.blob();
          })
          .then((blob: any) => {
            csvName = 'product-export.xlsx';          
            vm.downloadDocFromBlob(blob, csvName, contentType);
          })
          .catch(() => {
            vm.openModalError("Errore generico");
          })
      }

      vm.stopLoading();
    },
    exportPptx: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let filename = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractPptx(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
            return response.blob();
          })
          .then((blob: any) => {
            filename = 'product-export.pptx';
            vm.downloadDocFromBlob(blob, filename, contentType);
          })
          .catch(() => {
            vm.openModalError("Errore generico");
          })
      }

      vm.stopLoading();
    },
    downloadDocFromBlob(blob: any, name: string, contentType: string) {
      const newBlob = new Blob([blob], { type: contentType });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, name);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = objUrl;
        link.target = '_blank';
        link.download = name;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
      }
    },
    addProduct: async function() {
      const vm = this as any;

      vm.$router.push({ name: 'danni-non-auto', params: {user: vm.loggedUser}});
    },
    modifyProduct: async function(row: any) {
      const vm = this as any;

      const productIdsFilter = [] as any;
      if (row !== undefined) {
        productIdsFilter.push(vm.listaProdottiCensitiForTable[row].productId);
      } else {
        let i;
        for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
          if (vm.listaProdottiCensitiForTable[i].isSelected) {
            productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
          }
        }
      }

      let productIdToModify = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da modificare.");
      } else {
        productIdToModify = productIdsFilter[0];
        vm.$router.push({ name: 'danni-non-auto', params: {user: vm.loggedUser, productId: productIdToModify}});
      }
    },
    showProduct: async function(row: any) {
      const vm = this as any;

      let p = null as any;
      let op = null as any;
      const productFilter = [] as any;
      if (row !== undefined) {
        p = vm.listaProdottiCensitiForTable[row];
        op = vm.listaProdottiCensiti[row];
      }

      if (p == null) {
        vm.openModalError("Selezionare un solo prodotto da visualizzare.");
      } else {
        vm.product = p;
        vm.productName = null;
        if (op !== undefined && op !== null) {
          vm.productName = op.properties[0].value;
        }
        if (vm.productName === undefined || vm.productName === null) {
          vm.productName = vm.product.prodotto;
        }
        vm.$bvModal.show("modal-show");
      }
    },
    showSectionName: function(col: any) {
      const vm = this as any;

      return col.sectionName !== undefined || col.field == 'innovazione' || col.field == 'note';
    },
    showProductValue: function(col: any) {
      const vm = this as any;

      if (col.checkVisibile && !vm.isAdmin()) {
        return false;
      }

      const field = col.field;
      if (field == 'isSelected' || field == 'isToModify' || field == 'prodottoCompleto' || field == 'productCode') {
        return false;
      }

      if (vm.product[field] == undefined) {
        return false;
      }

      let value = vm.getProductValue(field);

      let isNoteFieldEmpty = false;
      if (field == 'note' && vm.isEmptyOrSpaces(value)) {
        isNoteFieldEmpty = true;
      }

      return value != vm.ND && value != "<div></div>" && value != "<div>"+vm.ND+"</div>" && !col.modalShowHidden && !isNoteFieldEmpty;
    },
    getProductValue: function(field: any) {
      const vm = this as any;

      let v = vm.product[field];

      let value = '';
      if (v.printableModalValue != undefined && v.printableModalValue != '') {
        value = v.printableModalValue;
      } else if (v.printableValue != undefined && v.printableValue != '') {
        value = v.printableValue;
      } else if (v.printableModalValue == undefined && v.printableValue == undefined) {
        value = v;
      }

      return value;
    },
    existsOneFieldOfSectionNotND: function(sectionName: string) {
      const vm = this as any;

      let isReachedSectionName = false;
      let isReachedNextSectionName = false;
      let existsOneFieldOfSectionNotND = false;
      vm.columns.forEach((col: any) => {
        if (isReachedSectionName && col.sectionName !== undefined) {
          isReachedNextSectionName = true;
        }
        if (!isReachedSectionName && col.sectionName == sectionName) {
          isReachedSectionName = true;
        }
        if (isReachedSectionName && !isReachedNextSectionName) {
          existsOneFieldOfSectionNotND = existsOneFieldOfSectionNotND || vm.showProductValue(col);
        }
      });

      return existsOneFieldOfSectionNotND;
    },
    confirmDuplicateProduct() {
      const vm = this as any;

      vm.operationToConfirm = "DUPLICATE";
      vm.openModalConfirmOperation("Si conferma di voler clonare il prodotto?");
    },    
    duplicateProduct: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      let productIdToDuplicate = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da duplicare.");
      } else {
        productIdToDuplicate = productIdsFilter[0];

        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .duplicateProduct({productId : productIdToDuplicate})
          .then(handleResponse)
          .then((result: any) => {
            vm.stopLoading();
            vm.openModalSuccess("Duplicazione prodotto avvenuta con successo (productCode = " + result.productCode + ")");
            vm.retrieveProductsList();
            return null;
          })
          .catch(() => {
            vm.openModalError("Errore generico");
          })
      }
    },
    confirmDeleteProductsList() {
      const vm = this as any;

      vm.operationToConfirm = "DELETE";
      vm.openModalConfirmOperation("Si conferma di voler eliminare il prodotto?");
    },
    deleteProductsList: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      vm.startLoading();

      const serviceCallReturnValue = await requestService.deleteProductsList({ids : productIdsFilter})
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.openModalSuccess("Eliminazione prodotti avvenuta con successo.");
          vm.retrieveProductsList();
          return null;
        })
        .catch(() => {
          vm.openModalError("Errore generico");
        })
    },
    _compare: function(a: any, b: any) {
      const aCode = a.code;
      const bCode = b.code;
      if (aCode === undefined || bCode === undefined) {
        if (bCode !== undefined) {
          return -1;
        }
        if (aCode !== undefined) {
          return 1;
        }
        return 0;
      }

      let aSplit = aCode.split(".");
      let bSplit = bCode.split(".");
      if (aSplit.length > 1 && bSplit.length > 1) {
        let aPre = parseInt(aSplit[0]);
        let aPost = parseInt(aSplit[1]);
  
        let bPre = parseInt(bSplit[0]);
        let bPost = parseInt(bSplit[1]);

        if (aPre == bPre) {
          if (aPost < bPost) {
            return -1;
          }
          if (aPost > bPost) {
            return 1;
          }
          return 0;
        } else if (aPre < bPre) {
          return -1;
        } else {
          return 1;
        }
      }

      if (aCode < bCode) {
        return -1;
      }
      if (aCode > bCode) {
        return 1;
      }
      return 0;
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    printStringListItem(item: any) {
      return (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign
    },
    clean(s: any) {
      let str = s;
      str = str.replace(/'/g, "&apos;");
      str = str.replace(/"/g, "&quot;");
      return str;
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      let printableValue = "";
      let tooltipValue = "";
      let printableModalValue = "";

      if (property === undefined || property == null) {
        return {printableValue:printableValue,tooltipValue:tooltipValue,printableModalValue:printableModalValue};
      }

      if (property.type == propertyTypes.VALUES) {
        let splitList = false;
        if (property.values.length > 0) {
          property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            const s = vm.splitString(item.description);
            printableValue = s[0];
            tooltipValue = s[1];
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let lis: any[] = [];
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              let s = vm.splitString(item.description)[0];

              splitList = true;
              const auxS = s.replace(/></gi, ">###<");
              const auxSItems = auxS.split("###");
              s = "";
              let i;
              for (let i = 0; i < auxSItems.length && liCounter < maxLi; i++) {
                liCounter++;
                if (liCounter == maxLi) {
                  auxSItems[i] = auxSItems[i].replace(/<\/div>/i, " ...</div>");
                }
                s = s + auxSItems[i];
              }

              if (s != "") {
                lis.push("<li>" + s + "</li>");
              } 

              return "<li>" + vm.clean(item.description) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
            if (liCounter > maxLi || (splitList && liCounter == maxLi)) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
            }
          }
        } else {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (property.type == propertyTypes.STRING_LIST) {
        if (property.value !== "") {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          const s = vm.splitString(vm.printStringListItem(item));
          printableValue = s[0];
          tooltipValue = s[1];
        } else {
          const maxLi = 3;
          let liCounter = 0;
          let lis: any[] = [];
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            liCounter++;
            lis.push("<li>" + item.value + item.valueSign + "</li>");
            return "<li>" + vm.clean(item.value + item.valueSign) + "</li>";
          }).join("");

          if (liCounter > maxLi) {
            let spliced = lis.splice(0, maxLi);
            const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
            spliced[maxLi-1] = s;
            li = spliced.join("");
          } else {
            li = lis.join("");
          }

          printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
          if (liCounter > maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
          }
        }
      } else if (property.type == propertyTypes.FRAZIONAMENTO) {
        if (property.value === vm.ND) {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        } else {
          let values: any[] = [];
          if (property.frazionamento.mensile !== vm.ND) {
            values.push("Mensile: " + property.frazionamento.mensile + property.frazionamento.mensileSign);
          }
          if (property.frazionamento.bimestrale !== vm.ND) {
            values.push("Bimestrale: " + property.frazionamento.bimestrale + property.frazionamento.bimestraleSign);
          }
          if (property.frazionamento.trimestrale !== vm.ND) {
            values.push("Trimestrale: " + property.frazionamento.trimestrale + property.frazionamento.trimestraleSign);
          }
          if (property.frazionamento.quadrimestrale !== vm.ND) {
            values.push("Quadrimestrale: " + property.frazionamento.quadrimestrale + property.frazionamento.quadrimestraleSign);
          }
          if (property.frazionamento.semestrale !== vm.ND) {
            values.push("Semestrale: " + property.frazionamento.semestrale + property.frazionamento.semestraleSign);
          }
          if (values.length == 1) {
            printableValue = values[0];
          } else if (values.length > 1) {
            const maxLi = 3;
            let liCounter = 0;
            let lis: any[] = [];
            let li = "";
            const tooltipLi = values.map(function(s: any) {
              liCounter++;
              lis.push("<li>" + s + "</li>");
              return "<li>" + vm.clean(s) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<ul class='dashed'>" + li + "</ul>"
            if (liCounter > maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
            }
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (property.value !== undefined && property.value !== null) {
        const s = vm.splitString(vm.printWithSign(property));
        printableValue = s[0];
        tooltipValue = s[1];
      }

      if (tooltipValue !== undefined && !this.isEmptyOrSpaces(tooltipValue)) {
        printableModalValue = tooltipValue;
        tooltipValue = vm.escapeHtml(tooltipValue);
      }

      return {printableValue:printableValue,tooltipValue:tooltipValue,printableModalValue:printableModalValue};
    },
    printNewLine(s: any) {
      if (s !== undefined) {
        return s
          .replace(/\n/g, "<br/>")
          .replace(/\'/g, "&rsquo;")
      }

      return s;
    },
    splitString(str: any) {
      const vm = this as any;

      const maxRows = 3;
      const maxCharsPerRow = 40;
      let printableValue = "";
      let tooltipValue = "";

      if (str === undefined) {
        return [printableValue, tooltipValue];
      }

      let brArray = str.split("\n");
      let brDiv = [] as any;
      brArray.forEach((item: any) => {
        let itemWords = item.split(" ");
        let concatWords = "";
        for (let i = 0; i < itemWords.length; i++) {
          let word = itemWords[i];
          if (i == 0) {
            concatWords = word;
          } else {
            if ((concatWords + word).length < maxCharsPerRow) {
              concatWords = concatWords + " " + word;
            } else {
              brDiv.push(concatWords);
              concatWords = word;
            }
          }

          // gestione last element
          if (i+1 == itemWords.length) {
            brDiv.push(concatWords);	
          }
        }
      });

      let flagDots = false;
      if (brDiv.length > maxRows) {
        flagDots = true;
        for (let i = 0; i < maxRows; i++) {
          let s = brDiv[i];
          if (i == maxRows - 1) {
            s += " ...";
          }
          printableValue += "<div>" + s + "</div>";
        }
      } else {
        for (let i = 0; i < brDiv.length; i++) {
          printableValue += "<div>" + brDiv[i] + "</div>";
        }
      }

      if (flagDots) {
        tooltipValue = vm.printNewLine(str);
      }

      return [printableValue, tooltipValue];
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    printWithSign(property: any, left: boolean) {
      const vm = this as any;

      const value = vm.stringify(property.value);
      if (value != '' && value != vm.ND) {
        const sign = vm.stringify(property.valueSign !== undefined ? property.valueSign : "");

        const spacing = sign.indexOf('€') >= 0 || sign.indexOf('ann') >= 0 ? ' ' : '';

        if (left) {
          return sign + spacing + value;
        }
        return value + spacing + sign;
      }

      return value;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    openModalConfirmOperation(msg: string) {
      const vm = this as any;
      vm.msgConfirmOperation = msg;
      vm.$bvModal.show("modal-confirm-operation");
    },
    closeModalConfirmOperation() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-operation");
    },
    onClickReturnConfirmOperation() {
      const vm = this as any;
      if (vm.operationToConfirm == "DELETE") {
        vm.deleteProductsList();
      } else if (vm.operationToConfirm == "DUPLICATE") {
        vm.duplicateProduct();
      }
      vm.operationToConfirm == "";
      vm.closeModalConfirmOperation();
    },
    closeModalShow() {
      const vm = this as any;
      vm.$bvModal.hide("modal-show");
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    isAdmin: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('admin-view') >= 0;
      }
      return false;
    },
    isAdvanced: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('advanced') >= 0;
      }
      return false;
    },
    noDashboard: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('no-dashboard') >= 0;
      }
      return false;
    },
    isModifyProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('modifica-prodotto') >= 0;
      }
      return false;
    },
    isDuplicateProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('duplica-prodotto') >= 0;
      }
      return false;
    },
    isDeleteProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('elimina-prodotto') >= 0;
      }
      return false;
    },
    prepareJqueryEvents: function() {
      const vm = this as any;

      vm.destroyJqueryEvents();

      jquery("div.dataTables_scrollFoot").hide();

      (jquery('[data-toggle="tooltip"]') as any).tooltip();

      vm.scrollTables = jquery("div.dataTables_scrollHead, div.dataTables_scrollBody");

      jquery(".selectProd").on("click", vm.selectProdClick);
      jquery(".modifyProd").on("click", vm.modifyProdClick);
      jquery(".showProd").on("click", vm.showProdClick);

      jquery(".multiheader[colspan='1']").addClass('force-width');
      jquery(".multiheader[colspan='1'] > div").addClass('force-width');

      if (vm.selectAll) {
        // nel caso in cui cambi "pagina" della tabella con selectAll = true
        jquery('.selectProd').prop('checked', vm.selectAll);
      }
    },
    destroyJqueryEvents: function() {
      const vm = this as any;

      (jquery('[data-toggle="tooltip"]') as any).tooltip('dispose');

      jquery(".selectProd").off("click", vm.selectProdClick);
      jquery(".modifyProd").off("click", vm.modifyProdClick);
      jquery(".showProd").off("click", vm.showProdClick);
    },
    scrollTo: function(id: string) {
      const vm = this as any;

      const elementToScrollTo = jquery('#' + id);
      if (elementToScrollTo != undefined && elementToScrollTo.offset() != undefined) {
        const offset = elementToScrollTo.offset();

        const body = jquery("div.dataTables_scrollBody");
        var bodyLeft = body.scrollLeft();
        if (bodyLeft == undefined) {
          bodyLeft = 0;
        }

        if (offset != undefined) {
          const offsetLeft = offset.left - 50;
          vm.scrollTables.scrollLeft(bodyLeft + offsetLeft, 0);
        }
      }
    },
    selectProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isSelectedProd_'.length);
        vm.setIsSelected(id);
      }
    },
    modifyProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isToModifyProd_'.length);
        (jquery('#'+event.currentTarget.id) as any).tooltip('dispose');
        vm.modifyProduct(id);
      }
    },
    showProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isToShowProd_'.length);
        vm.showProduct(id);
      }
    },
    escapeHtml(value: string) {
      return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    handlePageInput(val: number) {
      const vm = this as any;
      vm.page = val;
      vm.listaProdottiCensitiCurrent = vm.listaProdottiCensitiPaginati[val-1];
      
      const sizeLastPage = (vm.page - 1)*vm.itemsPerPage;
      vm.pageStart = sizeLastPage + 1;
      vm.pageEnd = sizeLastPage + vm.listaProdottiCensitiCurrent.length;
    },
  },
  mounted() {
    const vm = this as any;

    if (!vm.loggedUser) {
      vm.homeProdotti();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('danni-non-auto') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.homeProdotti();
      }
    }

    vm.columns.forEach(function (c: any) {
      if (!c.orderable) {
        c.orderable = false;
      }
      if (c.checkVisible) {
        c.visible = vm.isAdmin();
      }
    });
  },
  beforeDestroy() {
    const vm = this as any;

    vm.destroyJqueryEvents();
  },
  created() {
    if (!this.isAdmin()) {
      //this.options.fixedColumns.leftColumns = 5; // prodotto (vanno contate anche quelle non visibili per ruolo)
      this.options.fixedColumns.leftColumns = 0;
    } else {
      this.options.fixedColumns.leftColumns = 0;
    }

    this.inizializzaFiltroRicerca();

    this.getPropertyValues()
      .then(result => {
        this.resetFilterOptions();
      });

    this.retrieveProductsList();
  }
});
